import type { AppsFlyerResult } from '../../utils';

/**
 * AppsFlyer integration.
 * Disabled on web.
 */
export const useAppsFlyer = (): AppsFlyerResult => {
  return mockAppsFlyer;
};

const mockAppsFlyer: AppsFlyerResult = {
  async initializeAppsFlyer() {},
  setCustomerUserId(_customerId) {},
  logPurchaseEvent(_payload) {},
};
